import { render, staticRenderFns } from "./PassProve.vue?vue&type=template&id=6c07f44b&"
import script from "./PassProve.vue?vue&type=script&lang=js&"
export * from "./PassProve.vue?vue&type=script&lang=js&"
import style0 from "./PassProve.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports